import { Component, OnInit } from '@angular/core';
import { NavigationActionBase } from '../../navigation-action-base';

/**
 * Properties navigation component
 */
@Component({
  selector: 'properties-navigation',
  styleUrls: ['./properties-navigation.component.css'],
  templateUrl: './properties-navigation.component.html'
})
export class PropertiesNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
* Export properties to Excel
* */
  exportToExcel() {
    this.eventBus.broadcastEvent('exportToExcelPropertiesGrid');
  }
}
